// Confirmation Modal Component
// Provides a native Dawn theme confirmation modal to replace browser alerts

// Translation strings
const modalTranslations = {
  en: {
    title: 'Limit Exceeded',
    okButton: 'OK'
  },
  fr: {
    title: 'Limite Dépassée',
    okButton: 'OK'
  }
};

// Get current language (default to English)
function getCurrentLanguage() {
  const htmlLang = document.documentElement.lang;
  if (htmlLang && htmlLang.startsWith('fr')) {
    return 'fr';
  }
  return 'en';
}

window.showConfirmationModal = function(message, onConfirm = null, onCancel = null) {
  // Remove existing modal if any
  const existingModal = document.querySelector('.confirmation-modal');
  if (existingModal) {
    existingModal.remove();
  }

  // Get current language and translations
  const currentLang = getCurrentLanguage();
  const translations = modalTranslations[currentLang];

  // Create modal container
  const modal = document.createElement('div');
  modal.className = 'confirmation-modal';
  modal.setAttribute('open', '');
  
  // Create modal content
  modal.innerHTML = 
    '<div class="confirmation-modal__content" role="dialog" aria-modal="true" tabindex="-1">' +
      '<div class="confirmation-modal__header">' +
        '<h2 class="confirmation-modal__title">' + translations.title + '</h2>' +
        '<button id="ModalClose-confirmation" type="button" class="modal__close-button link" aria-label="Close">' +
          '<svg class="icon icon-close" aria-hidden="true" focusable="false">' +
            '<use href="#icon-close"></use>' +
          '</svg>' +
        '</button>' +
      '</div>' +
      '<div class="confirmation-modal__body">' +
        '<p class="confirmation-modal__message">' + message + '</p>' +
      '</div>' +
      '<div class="confirmation-modal__footer">' +
        '<button type="button" class="button button--primary confirmation-modal__confirm">' + translations.okButton + '</button>' +
      '</div>' +
    '</div>';

  // Add to body
  document.body.appendChild(modal);
  document.body.classList.add('overflow-hidden');

  // Add event listeners
  const confirmBtn = modal.querySelector('.confirmation-modal__confirm');
  const closeBtn = modal.querySelector('#ModalClose-confirmation');

  function hideModal() {
    document.body.classList.remove('overflow-hidden');
    modal.remove();
  }

  function handleConfirm() {
    hideModal();
    if (onConfirm) onConfirm();
  }

  function handleCancel() {
    hideModal();
    if (onCancel) onCancel();
  }

  confirmBtn.addEventListener('click', handleConfirm);
  closeBtn.addEventListener('click', handleCancel);

  // Close on backdrop click
  modal.addEventListener('click', (event) => {
    if (event.target === modal) {
      handleCancel();
    }
  });

  // Close on escape key
  const handleEscape = (event) => {
    if (event.code === 'Escape') {
      handleCancel();
      document.removeEventListener('keyup', handleEscape);
    }
  };
  document.addEventListener('keyup', handleEscape);

  // Focus the modal
  if (typeof trapFocus === 'function') {
    // eslint-disable-next-line no-undef
    trapFocus(modal, modal.querySelector('[role="dialog"]'));
  }
}; 